// extracted by mini-css-extract-plugin
export var readonly = "_i2-1";
export var star = "_i2-0";